<template>
  <div>
    <vxe-form
        ref="xForm"
        title-align="right"
        title-width="120"
        :data="formData"
        @submit="submit"
    >
      <vxe-form-item title="会员类别" field="loginName" span="24">
        <RadioGroup v-model="formData.vipType" @on-change="onChange">
          <Radio :label="0" :disabled="!isEdit">普通会员</Radio>
          <Radio :label="1" :disabled="!isEdit">黄金会员</Radio>
          <Radio :label="2" :disabled="!isEdit">铂金会员</Radio>
          <Radio :label="3" :disabled="!isEdit">钻石会员</Radio>
        </RadioGroup>
      </vxe-form-item>
      <vxe-form-item title="过期时间" field="passTime" span="24">
        <vxe-input type="datetime" v-model="formData.passTime" :disabled="!isEdit || formData.vipType === 0"
                   style="width: 400px"></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="船舶动态订阅数" field="addShipCount" span="24">
        <vxe-input v-model="formData.addShipCount" type="number" :readonly="!isEdit" style="width: 400px"></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="目的港订阅数" field="pushCount" span="24">
        <vxe-input v-model="formData.pushCount" type="number" :readonly="!isEdit" style="width: 400px"></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="查看企业数" field="loginName" span="24">
        <vxe-input v-model="formData.shipCompCount" type="number" :readonly="!isEdit" style="width: 400px"></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="轨迹查询时长" field="countTrackMonth" span="24" v-if="formData.vipType !== 0">
        <div class="flex">
          <vxe-input v-model="formData.countTrackMonth" type="number" :readonly="!isEdit"
                     style="width: 400px;margin-right: 5px"></vxe-input>
          月
        </div>
      </vxe-form-item>
      <vxe-form-item title="轨迹日上限次数" field="countTrack" span="24" v-if="formData.vipType !== 0">
        <div class="flex">
          <vxe-input v-model="formData.countTrack" type="number" :readonly="!isEdit"
                     style="width: 400px;margin-right: 5px"></vxe-input>
          次
        </div>
      </vxe-form-item>
      <vxe-form-item title="最后编辑人" field="updateUser" span="24">
        <span>{{ formData.updateUser }}</span>
      </vxe-form-item>
      <vxe-form-item title="今天剩余企业数" field="countShipCompToday" span="24">
        <span>{{ formData.countShipCompToday }}</span>
        <Button icon="ios-time-outline" style="color: #1A8CFE;margin-left: 10px;border-radius: 5px"
                @click="openHistory">历史记录
        </Button>
      </vxe-form-item>
      <vxe-form-item align="right" span="24" style="margin-top: 20px" v-if="isEdit">
        <vxe-button style="width: 140px; border-radius: 5px" @click="cancel()">取消</vxe-button>
        <vxe-button type="submit" status="primary" style="width: 140px; border-radius: 5px">确定</vxe-button>
      </vxe-form-item>
      <vxe-form-item align="right" span="24" style="margin-top: 20px" v-if="!isEdit">
        <vxe-button status="primary" style="width: 140px; border-radius: 5px" @click="isEdit = true">编辑</vxe-button>
      </vxe-form-item>
    </vxe-form>
    <vxe-modal v-model="historyModal" width="700" height="600" position="center" title="历史记录" destroy-on-close transfer>
      <history ref="history" :userId="userId" @close="historyModal = false"></history>
    </vxe-modal>
  </div>
</template>
<script>

import $api from "@/apiProvider";
import {hideLoading, showLoading} from "@/utils/util";
import History from "@/components/userManage/History";

export default {
  props: ['vipData', 'userId'],
  components: {History},
  data() {
    return {
      formData: {},
      isEdit: false,
      vipRules: [],
      historyModal: false
    }
  },
  watch: {
    vipData: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.formData = val;
        this.formData.passTime = this.$utils.toDateString(val.passTime, "yyyy-MM-dd HH:mm:ss");
      }
    }
  },
  mounted() {
    this.queryVipRuleList();
  },
  methods: {
    openHistory() {
      this.historyModal = true;
    },
    submit() {
      this.editUserVipInfo();
    },
    cancel() {
      this.isEdit = false;
      this.$emit('afterSave');
    },
    onChange(value) {
      if (value === 0) {
        this.formData.vipLv = '普通会员';
        this.formData.note = '普通会员';
        this.formData.passTime = null;
        this.formData.addShipCount = 5;
        this.formData.pushCount = 1;
        this.formData.shipCompCount = 0;
        this.formData.countTrackMonth = 0;
        this.formData.countTrack = 0;
      } else {
        this.vipRules.map(i => {
          if (i.vipType === value) {
            this.formData.addShipCount = i.addShipCount;
            this.formData.pushCount = i.pushCount;
            this.formData.shipCompCount = i.shipCompCount;
            this.formData.vipLv = i.vipDesc;
            this.formData.note = i.vipDesc;
            this.formData.countTrackMonth = i.countTrackMonth;
            this.formData.countTrack = i.countTrack;
          }
        })
      }
    },
    async queryVipRuleList() {
      let res = await $api.seachart.request("queryVipRuleList", {});
      if (res.code === 1) {
        this.vipRules = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async editUserVipInfo() {
      let obj = Object.assign({}, this.formData);
      obj.userId = this.userId;
      if (obj.passTime) {
        obj.passTime = this.$utils.timestamp(obj.passTime);
      }
      if (obj.countTrackLongPassTime) {
        obj.countTrackLongPassTime = this.$utils.timestamp(obj.countTrackLongPassTime);
      }
      showLoading();
      let res = await $api.seachart.request("editUserVipInfo", obj);
      hideLoading();
      if (res.code === 1) {
        this.$Message.success('修改成功');
        this.$emit('afterSave');
        this.isEdit = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
  }
}
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
}
</style>